export const generic_errors = {
    'en':{
        INCOMPLETE_FORM:'Fill in the missing fields'
    }
    
}